export default "__VITE_ASSET__58e687e1__"